import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Grid, useTheme, useMediaQuery } from "@mui/material";
import NavBar from "./NavBar";
import TopBar from "./TopBar";
import { Outlet } from 'react-router-dom';
// import CopyRight from "src/components/CopyRight"; // You can uncomment if needed

function DashboardLayout({ children }) {
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        display: "flex",
        height: "100vh",
        overflow: "hidden",
        width: "100%",
        flexDirection: "column"
      }}
    >
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <Box
        component="main"
        sx={{
          display: "flex",
          flex: "1 1 auto",
          overflow: "hidden",
          pt: "64px",
          pl: isLgUp ? "256px" : 0,
        }}
      >
        <Box
          sx={{
            flex: "1 1 auto",
            height: "100%",
            overflow: "auto",
            width: "100%",
          }}
        >
          {children}
          <Outlet />
        </Box>
      </Box>
      {/* Optional footer */}
      {/* 
      <Box sx={{ width: "100%", display: "flex", justifyContent: "center", py: 2 }}>
        <CopyRight />
      </Box> 
      */}
    </Box>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
